import UserProfile from '@/entities/UserProfile';
import axios from 'axios';
import _ from 'lodash';

const ls = require('local-storage');

export default {
  async verifyLoginCode(email, code) {
    const exceptionError = {
      status: 'EXCEPTION',
      message: 'Une erreur est survenue, merci de réessayer',
    };
    try {
      const url = `${process.env.VUE_APP_MON_COMPTE_BACKEND_URL}/authenticateShopWithLoginCode`;
      const { data } = await axios.post(url, {
        email,
        code,
      });

      if (data.token) {
        return { token: data.token };
      }

      if (data.message && data.status) {
        return { token: null };
      }
    } catch (error) {
      if (_.has(error, 'response.data.status') && _.has(error, 'response.data.message')) {
        return { token: null, error: error.response.data };
      }
      return { token: null, error: exceptionError };
    }
    return { token: null, error: exceptionError };
  },

  async sendLoginCode(email) {
    const url = `${process.env.VUE_APP_MON_COMPTE_BACKEND_URL}/requestShopLoginCode`;
    const res = await axios.get(url, {
      params: {
        email,
      },
    });
    return res;
  },

  async sendMagicLink(email) {
    console.log('email', email);
    const res = await axios.get(process.env.VUE_APP_REQUEST_SHOP_MAGIC_LINK_ENDPOINT, {
      params: {
        callbackURL: `${window.location.origin}${process.env.VUE_APP_MAGIC_LINK_CALLBACK_ENDPOINT}`,
        email,
      },
    });
    return res;
  },

  async listAllUsers() {
    const url = process.env.VUE_APP_LIST_USERS_ENDPOINT;
    const shopToken = ls.get('shopToken');

    const { data } = await axios.get(url, { headers: { 'shop-token': shopToken } });

    const users = data.map((user) => new UserProfile(user));

    return users;
  },

  async loginWithMagicLinkToken(token) {
    return Promise.resolve(ls.set('shopToken', token));
  },

  async logout() {
    return Promise.resolve(ls.unsetShopToken('shopToken'));
  },
};
